import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PartnerLogo from "assets/images/partner-logo.png";
import CuverdLogo from "assets/images/cuverd-logo-header.png";
import ProfessionalLogo from "assets/images/professional-logo.png";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import mobileTopArc from "assets/images/mobile-top-curve.svg";
import mobileBottom from "assets/images/mobile-bottom-curve.svg";
import { Field, getFormSyncErrors, getFormValues, reduxForm } from "redux-form";
import { renderTextField } from "components/FormFields/FieldTypes";
import { Required } from "components/FormFields/validators";
import { authenticationActions as authActions } from "actions";
import MessageDialog from "pages/SearchMedication/MessageDialog";
import { v4 as uuidv4 } from "uuid";

const WelcomeContent = (props) => {
  const {
    formErrors,
    formValues,
    onSaveClick,
    registerDevice,
    registerInfo,
    //getOrganizationDetails,
    organizationInfo,
  } = props;
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const checkCodeRequired =
    organizationInfo?.organizationOptionJson?.codeRequiredFlag?.toLowerCase() ===
    "y";
    const isHCPTemplate =
      organizationInfo?.type?.toLowerCase() === "h" &&
      organizationInfo?.app?.appCode?.toLowerCase() === "hcp";

    const Logo =
      organizationInfo?.app?.appCode === "CVD"
        ? CuverdLogo
        : isHCPTemplate
        ? ProfessionalLogo
        : PartnerLogo;

  // useEffect(() => {
  //   getOrganizationDetails();
  // }, []);

  useEffect(() => {
    if (
      (organizationInfo &&
        organizationInfo?.organizationOptionJson?.codeRequiredFlag?.toLowerCase() ===
          "n") ||
      localStorage.getItem("deviceId")
    ) {
      onSaveClick(false);
    }
  }, [organizationInfo]);

  useEffect(() => {
    if (registerInfo && registerInfo.success === false && loading) {
      setShowErrorDialog(true);
    } else if (registerInfo && registerInfo.success) {
      onSaveClick(false);
    }
  }, [registerInfo]);

  const onFormSubmit = (event) => {
    if (formValues) {
      const { passcode } = formValues;
      if (passcode) {
        setLoading(true);
        let browserInfo = navigator.userAgent;
        let browserType = "WEB";
        const deviceGUID = uuidv4();
        const appCode = localStorage.getItem("appCode");
        //localStorage.setItem("deviceId", deviceGUID);
        registerDevice(deviceGUID, browserType, browserInfo, appCode, passcode);
        event?.preventDefault();
      }
    }
  };

  return (
    <Box>
      {checkCodeRequired ? (
        <Box sx={{ position: "relative", height: "100vh" }}>
          <Box>
            <img
              src={mobileBottom}
              alt="mobile-arc"
              className="left-arc"
              style={{ width: "30%" }}
            />
          </Box>
          <Box>
            <img
              src={mobileTopArc}
              alt="mabile-arc"
              style={{
                width: "30%",
                position: "absolute",
                right: 0,
                bottom: 0,
              }}
            />
          </Box>
          <Box sx={{ paddingLeft: "24px", paddingRight: "24px" }}>
            <Grid
              container
              pt={4}
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <form onSubmit={(event) => onFormSubmit(event)}>
                <Grid item>
                  <Box
                    sx={{
                      width: matchesMinWidth ? "160px" : "240px",
                      margin: "auto",
                    }}
                  >
                    <img
                      src={Logo}
                      style={{ width: "100%", height: "100%" }}
                      alt="home-logo"
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  sx={{
                    marginTop: matchesMinWidth ? "45px" : "54px",
                    marginBottom: matchesMinWidth ? "100px" : "180px",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h1LatoBlack"
                      sx={{ fontSize: matchesMinWidth ? "30px" : undefined }}
                    >
                      WELCOME
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  sx={{
                    margin: "auto",
                    width: matchesMinWidth ? "100%" : "480px",
                  }}
                >
                  <Box>
                    <Field
                      name="passcode"
                      isRequired
                      component={renderTextField}
                      label="Get started by entering your company’s code below"
                      validate={Required}
                      autoFocus={true}
                      // handleKeyDown={(e) => {
                      //   if (
                      //     e.key &&
                      //     e.key == "Enter" &&
                      //     Object.keys(formErrors).length == 0
                      //   ) {
                      //     onFormSubmit();
                      //   }
                      // }}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={7}
                  sx={{
                    width: matchesMinWidth ? "100%" : "360px",
                    margin: "auto",
                    marginBottom: matchesMinWidth ? "20px" : "36px",
                    marginTop: "100px",
                    textAlign: "center",
                  }}
                >
                  <Box>
                    <Button
                      disabled={Object.keys(formErrors).length ? true : false}
                      variant="large"
                      type="submit"
                      // onClick={onFormSubmit}
                      sx={{
                        minWidth: "100%",
                        wordSpacing: 2,
                        backgroundColor:
                          formErrors && Object.keys(formErrors).length
                            ? "#e6e6e6"
                            : organizationInfo?.colorSchemeJson
                                ?.primaryButtonColor,
                        color:
                          formErrors && Object.keys(formErrors).length
                            ? "#637276"
                            : organizationInfo?.colorSchemeJson
                                ?.primaryButtonTextColor,
                        boxShadow: "none",
                        "&:hover": {
                          color:
                            organizationInfo?.colorSchemeJson
                              ?.primaryButtonTextColor,
                        },
                      }}
                    >
                      Start Saving
                    </Button>
                  </Box>
                </Grid>
              </form>
            </Grid>
          </Box>
          <MessageDialog showPopUp={showErrorDialog}>
            <form
              onSubmit={(event) => {
                setLoading(false);
                setShowErrorDialog(false);
                event?.preventDefault();
              }}
            >
              <Box>
                <Typography
                  variant={matchesMinWidth ? "h3LatoBold" : "h2LatoBold"}
                  sx={{
                    color: "#E94854",
                    lineHeight: matchesMinWidth ? "24px" : "26px",
                  }}
                >
                  We’re sorry. We don’t recognize that company code.
                  {matchesMinWidth ? null : <br />} Either try again or reach
                  out to your
                  {matchesMinWidth ? null : <br />} HR contact for assistance.
                </Typography>
              </Box>
              <Box mt={5}>
                <input
                  style={{
                    position: "absolute",
                    left: "-9999px",
                    width: "1px",
                    height: "1px",
                  }}
                  type="text"
                  value={2}
                  autoFocus
                />
                <Button type="submit" variant="filled">
                  TRY AGAIN
                </Button>
              </Box>
            </form>
          </MessageDialog>
        </Box>
      ) : null}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("WELCOME_FORM")(state) || {},
    formValues: getFormValues("WELCOME_FORM")(state),
    organizationInfo: state.organizationInfo.data,
    registerInfo: state.authentication.registerInfo,
  };
};

const mapDispatchToProps = {
  // getOrganizationDetails: () => authActions.getOrganizationDetails(),
  authenticateDevice: (value) => authActions.authenticateDevice(value),
  registerDevice: (deviceId, browserType, browserInfo, appCode, passcode) =>
    authActions.registerDevice(
      deviceId,
      browserType,
      browserInfo,
      appCode,
      passcode
    ),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "WELCOME_FORM",
  })(WelcomeContent)
);
